import React from 'react';
import moment from 'moment';

export default function DateDivider({ timestamp, borderWidth = "w-[80%] ", timeWidth = "w-full", isChatPopup }) {
    if (timestamp) {
        let time = '';
        if (moment(timestamp).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) {
            time = 'Today';
        } else if (moment(timestamp).format('YYYY-MM-DD') === moment().subtract(1, 'day').format('YYYY-MM-DD')) {
            time = 'Yesterday';
        } else {
            time = moment(timestamp).format('dddd, MMMM Do YYYY');
        }
        return (
            <div className={`flex w-full items-center`}>
                {<div className={`border ${borderWidth} border-scogoddd`}></div>}
                <div className={`max-w-max flex ${timeWidth} justify-center text-scogogray px-2`}>
                    <div>{time}</div>
                </div>
                {<div className={`border ${borderWidth} border-scogoddd`}></div>}
            </div>
        );
    }
};

